import { useCountryStore } from '$hooks/stores'
import { redirect, ROUTE_NAMES } from '$router/config'
import {
  deleteCountry,
  getCountries,
  postCountry,
  putCountry
} from '$services/api'
import { useRequest } from 'ahooks'
import { toast } from 'sonner'

export const useCountryService = () => {
  const updateCountries = useCountryStore(state => state.updateCountries)

  const reloadCountries = () => {
    fetchCountriesAsync().then(() => {
      redirect(ROUTE_NAMES.COUNTRIES, options => options)
    })
  }

  const {
    run: fetchCountries,
    runAsync: fetchCountriesAsync,
    loading: fetchingCountries
  } = useRequest(getCountries, {
    manual: true,
    onSuccess: ({ data }) => {
      updateCountries(data)
    },
    onError: () => {
      updateCountries([])
    }
  })

  const { run: createCountry, loading: creatingCountry } = useRequest(
    postCountry,
    {
      manual: true,
      onSuccess: () => {
        toast.success('Successfully Created!')
        reloadCountries()
      }
    }
  )

  const { run: updateCountry, loading: updatingCountry } = useRequest(
    putCountry,
    {
      manual: true,
      onSuccess: () => {
        toast.success('Successfully Updated!')
        reloadCountries()
      }
    }
  )

  const { run: removeCountry, loading: removingCountry } = useRequest(
    deleteCountry,
    {
      manual: true,
      onSuccess: () => {
        toast.success('Successfully Deleted!')
        reloadCountries()
      }
    }
  )

  return {
    fetchCountries,
    fetchCountriesAsync,
    fetchingCountries,

    createCountry,
    creatingCountry,

    updateCountry,
    updatingCountry,

    removeCountry,
    removingCountry
  }
}
